// The string multipling functions
/**
 * format.sprintf(argument_list)
 *
 * The string function like one in C/C++, PHP, Perl
 * Each conversion specification is defined as below:
 *
 * %[index][alignment][padding][width][precision]type
 *
 * index     - An optional index specifier that changes the order of the
 *             arguments in the list to be displayed.
 * alignment - An optional alignment specifier that says if the result should be
 *             left-justified or right-justified. The default is
 *             right-justified; a "-" character here will make it left-justified.
 * padding   - An optional padding specifier that says what character will be
 *             used for padding the results to the right string size. This may
 *             be a space character or a "0" (zero character). The default is to
 *             pad with spaces. An alternate padding character can be specified
 *             by prefixing it with a single quote ('). See the examples below.
 * width     - An optional number, a width specifier that says how many
 *             characters (minimum) this conversion should result in.
 * precision - An optional precision specifier that says how many decimal digits
 *             should be displayed for floating-point numbers. This option has
 *             no effect for other types than float.
 * type      - A type specifier that says what type the argument data should be
 *             treated as. Possible types:
 *
 * % - a literal percent character. No argument is required.
 * b - the argument is treated as an integer, and presented as a binary number.
 * c - the argument is treated as an integer, and presented as the character
 *     with that ASCII value.
 * d - the argument is treated as an integer, and presented as a decimal number.
 * u - the same as "d".
 * f - the argument is treated as a float, and presented as a floating-point.
 * o - the argument is treated as an integer, and presented as an octal number.
 * s - the argument is treated as and presented as a string.
 * x - the argument is treated as an integer and presented as a hexadecimal
 *     number (with lowercase letters).
 * X - the argument is treated as an integer and presented as a hexadecimal
 *     number (with uppercase letters).
 */
String.prototype.sprintf = function () {
  var frmt = this.valueOf().replace(/%%/g, '\0\0');
  var args = arguments;

  var result = '', prev = 0, index = 0, x;
  var re = /%(\d+[\$#])?([+-])?('.|0| )?(\d*)(\.\d*)?([bcdfosuxX])/g;
    /*
     * The re.exec() method returns the array with the following properties
     * witch are used in this function
     *    x.index contains the substring position found at the origin string
     *    x[0] contains the found substring
     *    x[1] contains the index specifier (as \d+\$ or \d+#)
     *    x[2] contains the alignment specifier ("+" or "-" or empty)
     *    x[3] contains the padding specifier (space char, "0" or defined as '.)
     *    x[4] contains the width specifier (as \d*)
     *    x[5] contains the floating-point precision specifier (as \.\d*)
     *    x[6] contains the type specifier (as [bcdfosuxX])
     */
  while (x = re.exec(frmt)) {
    if (x[1]) var ins = args[x[1].substring(0, x[1].length - 1)];
    else var ins = args[index];
    switch (x[6]) {
      case 'b':
        ins = Number(ins).toString(2);
        break;
      case 'c':
        ins = String.fromCharCode(ins);
        break;
      case 'd':
      case 'u':
        ins = Number(ins).toString(10);
        break;
      case 'f':
        ins = Number(ins);
        if (x[5].length > 1) ins = ins.toFixed(x[5].substr(1));
        else ins = ins.toExponential(x[4]);
        break;
      case 'o':
        ins = Number(ins).toString(8);
        break;
      case 's':
        ins = ins.toString();
        break;
      case 'x':
        ins = Number(ins).toString(16);
        break;
      case 'X':
        ins = Number(ins).toString(16).toUpperCase();
        break;
    }
    result += frmt.substring(prev, x.index);
    prev = x.index + x[0].length;
    if (!x[3]) x[3] = '';
    result += ins.padding(x[2] + x[4], x[3].substr(x[3].length - 1));

    index++;
  }
  if (prev < frmt.length) result += frmt.substr(prev);
  result = result.replace(/\0\0/g, '%');
  return result;
};

String.prototype.startsWith = function (needle) {
  return (this.indexOf(needle) == 0);
};

String.prototype.dup = function () {
  var val = this.valueOf();
  return val + val;
};

// The padding functions
String.prototype.padding = function (n, c) {
  if (!c) c = ' ';
  if (c.length > 1) c = c.charAt(0);
  var val = this.valueOf();
  var pad = c.repeat(Math.abs(n) - this.length);
  if (n < 0) {
    return val + pad;
  }
  return pad + val;
};

String.prototype.leftPad = function (n, c) {
  return this.padding(Math.abs(n), c);
};

String.prototype.rightPad = function (n, c) {
  return this.padding(-Math.abs(n), c);
};

String.prototype.trimToLength = function (m) {
  return (this.length > m)
        ? this.trim().substring(0, m).split(' ').slice(0, -1).join(' ') + '...'
        : this;
};

String.prototype.hashCode = function () {
  var hash = 0;
  if (this.length == 0) return hash;
  for (let i = 0; i < this.length; i++) {
    const char = this.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
};

// The number converting functions
Number.prototype.radix = function (r, n, c) {
  if (!c) c = '0';
  return this.toString(r).padding(n, c);
};

Number.prototype.bin = function (n, c) {
  return this.radix(0x02, (n) ? n : 16, c);
};

Number.prototype.oct = function (n, c) {
  return this.radix(0x08, (n) ? n : 6, c);
};

Number.prototype.dec = function (n, c) {
  return this.radix(0x0A, (n) ? n : 2, c);
};

Number.prototype.hexl = function (n, c) {
  return this.radix(0x10, (n) ? n : 4, c);
};

Number.prototype.hex = function (n, c) {
  if (!c) c = '0';
  return this.hexl().toUpperCase().padding(n, c);
};

(function () {
  var serializeXML = function (node, output) {
    var nodeType = node.nodeType;
    if (nodeType == 3) { // TEXT nodes.
            // Replace special XML characters with their entities.
      output.push(node.textContent.replace(/&/, '&amp;').replace(/</, '&lt;').replace('>', '&gt;'));
    } else if (nodeType == 1) { // ELEMENT nodes.
            // Serialize Element nodes.
      output.push('<', node.tagName);
      if (node.hasAttributes()) {
        var attrMap = node.attributes;
        for (var i = 0, len = attrMap.length; i < len; ++i) {
          var attrNode = attrMap.item(i);
          output.push(' ', attrNode.name, '=\'', attrNode.value, '\'');
        }
      }
      if (node.hasChildNodes()) {
        output.push('>');
        var childNodes = node.childNodes;
        for (var i = 0, len = childNodes.length; i < len; ++i) {
          serializeXML(childNodes.item(i), output);
        }
        output.push('</', node.tagName, '>');
      } else {
        output.push('/>');
      }
    } else if (nodeType == 8) {
            // TODO(codedread): Replace special characters with XML entities?
      output.push('<!--', node.nodeValue, '-->');
    } else {
            // TODO: Handle CDATA nodes.
            // TODO: Handle ENTITY nodes.
            // TODO: Handle DOCUMENT nodes.
      throw 'Error serializing XML. Unhandled node of type: ' + nodeType;
    }
  };

  var isParseError = function (parsedDocument) {
    if (parsedDocument.tagName.toLowerCase() == 'parsererror') {
      return true;
    }

        // parser and parsererrorNS could be cached on startup for efficiency
    var parser = new DOMParser(),
      errorneousParse = parser.parseFromString('<', 'text/xml'),
      parsererrorNS = errorneousParse.getElementsByTagName('parsererror')[0].namespaceURI;

    if (parsererrorNS === 'http://www.w3.org/1999/xhtml') {
      return parsedDocument.getElementsByTagName('parsererror').length > 0;
    }

    return parsedDocument.getElementsByTagNameNS(parsererrorNS, 'parsererror').length > 0;
  };
})();
